import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Cookies from "js-cookie";
import "./Dashboard.css";
import { Outlet } from "react-router-dom";
//harshada Bhasvar (30/6/2025)
//create sidebar to render the content of add consultant, postjob and more
const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("dashboard");
  const [selectedJob, setSelectedJob] = useState(null);
  const username = Cookies.get("username") || "User";
  const [sidebarPinned, setSidebarPinned] = useState(
    Cookies.get("sidebarPinned") === "true"
  );

  return (
    <div className="d-flex">
      <Sidebar
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
        isPinned={sidebarPinned}
        setIsPinned={setSidebarPinned}
        onSelectMenu={setSelectedMenu}
      />

      <div className="flex-grow-1 dashboard-main">
        <Header
          toggleSidebar={() => {
            if (!sidebarPinned) setSidebarOpen(!sidebarOpen);
          }}
          isSidebarOpen={sidebarOpen}
        />

        <main
          className={`bg-light  min-vh-100  d-flex flex-column mt-4 align-items-center justify-content-start app-wrapper`}
        >
          {<Outlet />}
        </main>

        {/* <footer className="text-center text-muted small py-3 border-top bg-white">
          © 2025 - Design and Developed by VRSamadhan Tech Solution <a href="#">Privacy</a>
        </footer> */}
      </div>
    </div>
  );
};

export default Dashboard;
